import RemindList from '@/pages/customManage/remindList'
// import FollowCustomList from '@/pages/customManage/followCustomList'
import FollowDetail from '@/pages/customManage/followCustomList/cusFollowDetail/FollowDetail'

export default [
  {
    path: '/remindList',
    name: 'RemindList',
    component: RemindList,
    meta: { name: '到期提醒' }
  },
  // {
  //   path: '/followCustomList',
  //   name: 'FollowCustomList',
  //   component: FollowCustomList,
  //   meta: { name: '客户列表' }
  // },
  {
    path: '/cusFollowDetail/FollowDetail/:orderId',
    name: 'FollowDetail',
    component: FollowDetail,
    props: true,
    meta: { name: ['客户列表', '客户详情'] }
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/remindList.js